import logger from 'utils/logger.util';

const L = logger('sumArray');

const sumArray = (array) => {
  if (!Array.isArray(array)) {
    L.warn('()', 'Invalid array:', array);
    return NaN;
  }

  const len = array.length;
  if (!len) {
    // empty array is not an error, but no need for a loop
    return 0;
  }

  let sum = 0;
  let index = 0;
  while (index < len) {
    const item = array[index];

    if (!Number.isFinite(item)) {
      L.warn('()', 'Invalid item:', item, 'at index:', index, 'of array:', array);
      return NaN;
    }

    sum += item;
    index += 1;
  }

  return sum;
};

// noinspection JSUnusedGlobalSymbols
export default sumArray;
